import React, { Component } from "react";
import YearEnd2022 from "./YearEnd2022";
import { connect } from "react-redux";
import { pmaActions } from "_store/_actions";
import UnderConstruction from "./UnderConstruction";
import { isPdfPrintVersion } from "./CommonEditor/pdfPrintVersion";
import { GetOAuthToken, IsValidSessionSwitch } from "common/storage";
import { isUserAdmin } from "common/roles/role";
import "./CommonEditor/ivyprestoFonts.scss";

const isAdminSessionAccess = () => {
  try {
    const token = GetOAuthToken();
    const oauthData = token ? JSON.parse(token) : null;
    return (
      (oauthData && isUserAdmin(oauthData.roleID)) || IsValidSessionSwitch()
    );
  } catch (err) {
    return IsValidSessionSwitch();
  }
};

class PMAEditor extends Component {
  async componentDidMount() {}
  flippedTeam = (agentData) => {
    if (
      !agentData ||
      !agentData.isMemberOfTeam ||
      !Array.isArray(agentData.teamMembers) ||
      agentData.teamMembers.length < 2
    ) {
      return agentData;
    }
    //adding comment
    // Team of 3 (Kelseys): [1], [2], [0] with [1] as main agent
    if (
      String(agentData.listgenUserID ?? "") === "116921" &&
      agentData.teamMembers.length >= 3
    ) {
      const [first, second, third] = agentData.teamMembers;
      const updatedFirstMemberInfo = {
        agentDesignation: second.agentDesignation,
        agentLicenseNumber: second.agentLicenseNumber,
        emailAddress: second.email,
        listgenUserFirstName: second.firstName,
        listgenUserLastName: second.lastName,
        mobilePhoneNo: second.phone,
      };

      return {
        ...agentData,
        ...updatedFirstMemberInfo,
        teamMembers: [second, third, first],
      };
    }

    const cloned2ndTeamMember = agentData.teamMembers[1];
    const updatedFirstMemberInfo = {
      agentDesignation: cloned2ndTeamMember.agentDesignation,
      agentLicenseNumber: cloned2ndTeamMember.agentLicenseNumber,
      emailAddress: cloned2ndTeamMember.email,
      // displayEmailAddress: cloned2ndTeamMember.email,
      listgenUserFirstName: cloned2ndTeamMember.firstName,
      listgenUserLastName: cloned2ndTeamMember.lastName,
      mobilePhoneNo: cloned2ndTeamMember.phone,
    };

    return {
      ...agentData,
      ...updatedFirstMemberInfo,
      teamMembers: [...agentData.teamMembers].reverse(),
    };
  };

  render() {
    let { printVersion, fromEditor, pdfPrintVersion } = this.props;
    pdfPrintVersion = !!pdfPrintVersion || isPdfPrintVersion();
    const {
      version,
      singleHOData,
      pma,
      MQCityDetails,
      quarterlyAreaTable,
      quarterlyCityTable,
      navbarData,
      coverPageDetails,
      testimonials,
      printTestimonials,
      yearEnd,
      aprilData,
      typeOfVersion,
      typeOfYEVersion,
      missionStatement,
      propertyPhotoDetailsDTO,
      pmaQuarterlyCombinedCityDTO,
      quadrantDetails,
      volunteerDetails,
      bubbleBoxes,
      oldPhotoDetails,
      photoTableData,
      recentActivityPhotoList,
      isDemo,
      altAgentData,
      dashboardValuation,
      miniTableDetailsDTO,
      agentFocusInfoList,
      designDetailsInfoList,
      tpTrends2WatchList,
      keyMarketAvgsList,
      showMedian,
      priceRangeDashBoardDetailsDTOArea,
      priceRangeDashBoardDetailsDTOCity,
    } = this.props;

    let showAllEditButtons = fromEditor;
    let { currentArea, isUnavailable } = this.props;
    if (currentArea.mailingStatus && currentArea.mailingStatus === "Approved") {
      showAllEditButtons = false;
    }

    currentArea = currentArea || {};
    const { mlsAreaID } = currentArea;
    let { agentData } = this.props;
    const { listgenUserID } = agentData || {};
    const normalizedListgenUserID = String(listgenUserID ?? "");
    console.log("this.props", this.props);
    if (!listgenUserID) {
      return null;
    }
    isUnavailable = false;
    // if (
    //   agentData.listgenUserFirstName == "Kyle" ||
    //   agentData.listgenUserFirstName == "Sarah" ||
    //   agentData.listgenUserLastName == "Sullivan" ||
    //   !fromEditor
    // ) {
    //   isUnavailable = false;
    // }
    //adding comment
    // if (
    //   agentData.listgenUserFirstName == "Kyle" ||
    //   (agentData.listgenUserFirstName == "Sarah" &&
    //     agentData.listgenUserLastName == "Sullivan") ||
    //   agentData.listgenUserLastName === "Buttorf" ||
    //   agentData.listgenUserLastName === "Visser" ||
    //   agentData.listgenUserFirstName == "Monika" ||
    //   !fromEditor
    // ) {
    //   isUnavailable = false;
    // }
    printVersion = true;

    // if (
    //   agentData.listgenUserFirstName === "Kyle" ||
    //   agentData.listgenUserFirstName === "Sarah" ||
    //   !fromEditor
    // ) {
    //   isUnavailable = false;
    // }

    if (
      agentData &&
      agentData.isMemberOfTeam &&
      (!Array.isArray(agentData.teamMembers) ||
        agentData.teamMembers.length < 2)
    ) {
      agentData.isMemberOfTeam = false;
      agentData.teamMembers = null;
      if (altAgentData) {
        altAgentData.isMemberOfTeam = false;
        altAgentData.teamMembers = null;
      }
    }

    if (
      normalizedListgenUserID === "104504" ||
      normalizedListgenUserID === "106397" ||
      normalizedListgenUserID === "106028" ||
      normalizedListgenUserID === "106999" ||
      normalizedListgenUserID === "108188" ||
      normalizedListgenUserID === "108206" ||
      normalizedListgenUserID === "108341" ||
      normalizedListgenUserID === "109834" ||
      normalizedListgenUserID === "102689" ||
      normalizedListgenUserID === "116921" ||
      normalizedListgenUserID === "114383"
    ) {
      agentData = this.flippedTeam(agentData);
    }

    if (mlsAreaID === "SCL-15L" || mlsAreaID === "ALA-3900AK") {
      currentArea.mlsNeighborhood = "Your Neighborhood";
    }
    if (mlsAreaID === "SCL-1SB") {
      currentArea.mlsNeighborhood = "Borello Ranch Estates & Alicante";
    }
    if (normalizedListgenUserID === "100560") {
      currentArea.mlsNeighborhood = "Coastal Ranch";
    }

    if (isUnavailable) {
      return (
        <UnderConstruction currentArea={currentArea} agentData={agentData} />
      );
    } else {
      return (
        <YearEnd2022
          pma={pma}
          printVersion={printVersion}
          fromEditor={fromEditor}
          pdfPrintVersion={pdfPrintVersion}
          version={version}
          agentData={agentData}
          hoData={singleHOData}
          currentArea={currentArea}
          navbarData={navbarData}
          coverPageDetails={coverPageDetails}
          yearEnd={yearEnd}
          testimonials={
            printVersion && !fromEditor ? printTestimonials : testimonials
          }
          typeOfVersion={typeOfVersion}
          typeOfYEVersion={typeOfYEVersion}
          aprilData={aprilData}
          propertyPhotoDetailsDTO={propertyPhotoDetailsDTO}
          pmaQuarterlyCombinedCityDTO={pmaQuarterlyCombinedCityDTO}
          quarterlyAreaTable={quarterlyAreaTable}
          quarterlyCityTable={quarterlyCityTable}
          quadrantDetails={quadrantDetails}
          agentFocusInfoList={agentFocusInfoList}
          designDetailsInfoList={designDetailsInfoList}
          tpTrends2WatchList={tpTrends2WatchList}
          oldPhotoDetails={oldPhotoDetails}
          photoTableData={photoTableData}
          recentActivityPhotoList={recentActivityPhotoList}
          isDemo={isDemo}
          MQCityDetails={MQCityDetails}
          bubbleBoxes={bubbleBoxes}
          missionStatement={missionStatement}
          altAgentData={altAgentData}
          volunteerDetails={volunteerDetails}
          dashboardValuation={dashboardValuation}
          miniTableDetailsDTO={miniTableDetailsDTO}
          showAllEditButtons={showAllEditButtons}
          keyMarketAvgsList={keyMarketAvgsList}
          showMedian={showMedian}
          priceRangeDashBoardDetailsDTOArea={priceRangeDashBoardDetailsDTOArea}
          priceRangeDashBoardDetailsDTOCity={priceRangeDashBoardDetailsDTOCity}
        />
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    testimonials: state.pma.testimonials,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSAT: (hoID, listgenUserID) => {
      dispatch(pmaActions.getSAT(hoID, listgenUserID));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PMAEditor);
